export function OutlineDocumentIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0027 9.25586V17.7126"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00146 15.2998L11.9999 12.8809L15.9983 15.2998"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M10.6685 18.9224L12.0029 17.7129L13.3373 18.9224"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M16.08 20.9242H6V5.92578H16.08C17.1408 5.92578 18 6.78489 18 7.84558V19.0044C18 20.0651 17.1408 20.9242 16.08 20.9242Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 5.92253L14.6304 4.81384C14.2848 3.78195 13.152 3.23961 12.1344 3.62357L6 5.92253"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
